__turbopack_context__.v({
  "button": "Button-module__8C-t3q__button",
  "button2XLarge": "Button-module__8C-t3q__button2XLarge",
  "buttonLarge": "Button-module__8C-t3q__buttonLarge",
  "buttonLinkColor": "Button-module__8C-t3q__buttonLinkColor",
  "buttonLinkGray": "Button-module__8C-t3q__buttonLinkGray",
  "buttonMedium": "Button-module__8C-t3q__buttonMedium",
  "buttonOnlyOneIcon": "Button-module__8C-t3q__buttonOnlyOneIcon",
  "buttonSecondaryColor": "Button-module__8C-t3q__buttonSecondaryColor",
  "buttonSecondaryGray": "Button-module__8C-t3q__buttonSecondaryGray",
  "buttonSmall": "Button-module__8C-t3q__buttonSmall",
  "buttonTernaryColor": "Button-module__8C-t3q__buttonTernaryColor",
  "buttonTernaryGray": "Button-module__8C-t3q__buttonTernaryGray",
  "buttonXLarge": "Button-module__8C-t3q__buttonXLarge",
});
